import React from 'react';
import { Pressable, TouchableOpacity, View, } from 'react-native';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, } from '@voltmoney/schema';
import Typography from '../typography/Typography';
import Space from '../space/Space';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import { ButtonBase } from '../button/Button.base';
const LimitCardList = ({ data, action, 
// onPressRefresh,
// refreshAction,
triggerAction, showTooltip = false, isDarkMode }) => {
    const handleAction = async (value) => {
        action &&
            triggerAction &&
            (await triggerAction({
                ...action,
                payload: {
                    ...action.payload,
                    value: value,
                },
            }));
    };
    const handleRefreshAction = async (value) => {
        //console.log(index);
        value.onPressRefresh && value.onPressRefresh();
        value.refreshAction &&
            triggerAction &&
            (await triggerAction({
                ...value.refreshAction,
                payload: {
                    value: value.payload,
                },
            }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                width: '100%',
                borderColor: isDarkMode ? 'white' : '#F1F3F5',
                borderWidth: 1,
            } }, data.map((item) => {
            console.log("Data received is", data);
            return (React.createElement(View, { style: {
                    backgroundColor: isDarkMode ? '#0D0D0D' : '#FFFFFF',
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    borderBottomColor: '#E4E7EC',
                    borderBottomWidth: 1,
                } },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'column',
                        } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                            } },
                            React.createElement(Typography, { label: item.label, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night, lineHeight: 18 }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            showTooltip ? (React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.XS, color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal })) : (React.createElement(React.Fragment, null))),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                            } },
                            React.createElement(Typography, { label: item.limitAmount, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: isDarkMode ? ColorTokens.DARK_GREY_THEME : ColorTokens.Grey_Charcoal, lineHeight: 18 }),
                            React.createElement(Space, { size: SizeTypeTokens.XS }),
                            item.isPrimaryAction ? (React.createElement(React.Fragment, null,
                                React.createElement(TouchableOpacity, { onPress: () => {
                                        handleRefreshAction(item);
                                    } },
                                    React.createElement(Typography, { id: 'txt_unlockCreditLimit_' + item.payload, label: ' View', fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.XS, color: ColorTokens.Primary_100, lineHeight: 18, paddingLeft: 6, paddingRight: 6, paddingBottom: 6, paddingTop: 6 })))) : (React.createElement(React.Fragment, null)))),
                    React.createElement(View, null,
                        React.createElement(Pressable, { onPress: () => handleAction(item.payload) }, item.isPrimaryAction ? (!isDarkMode ?
                            React.createElement(ButtonBase, { id: 'bt_unlockCreditLimit_getPortfolio' + item.payload, width: ButtonWidthTypeToken.CONTENT, label: 'Refresh portfolio', fontFamily: FontFamilyTokens.Inter, labelColor: ColorTokens.Primary_100, onPress: () => handleAction(item.payload), paddingHorizontal: SizeTypeTokens.NONE, paddingVertical: SizeTypeTokens.NONE, borderColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White, bgColor: isDarkMode ? ColorTokens.DARK_MODE : ColorTokens.White }) : React.createElement(React.Fragment, null,
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    handleAction(item.payload);
                                } },
                                React.createElement(Typography, { id: 'txt_unlockCreditLimit_' + item.payload, label: 'Refresh portfolio', fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Primary_100, lineHeight: 18, paddingBottom: 6, marginRight: 8, paddingTop: 6 })))) : (React.createElement(Button, { id: 'bt_unlockCreditLimit_getPortfolio' + item.payload, type: ButtonTypeTokens.MediumFilled, width: ButtonWidthTypeToken.CONTENT, label: 'Get portfolio', fontFamily: FontFamilyTokens.Inter, labelColor: ColorTokens.White, onPress: () => handleAction(item.payload) }))))),
                React.createElement(Space, { size: SizeTypeTokens.XS })));
        }))));
};
export default React.memo(LimitCardList);
export { LimitCardList };
